module.exports = __webpack_public_path__ + "img/Sunu-Widyatmoko@3x.f94ff6f7.png";